import {UrlLink} from '../../../applink/UrlLink';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {PcViewerCommentHeaderProps} from './PcViewerCommentHeaderProps.interface';

export function PcViewerCommentHeader({
  title,
  seriesId,
  onClickBack,
  onClickContentHome,
}: PcViewerCommentHeaderProps) {
  return (
    <div className="flex h-pc_viewer_header_height_px w-full items-center">
      <Icon
        type={IconType.NavigationBack}
        className="mr-16pxr h-24pxr w-24pxr shrink-0"
        onClick={onClickBack}
      />
      <Text className="font-medium1-bold flex-1 break-all text-theme-solid-100 line-clamp-1">
        {title}
      </Text>
      <UrlLink
        url={seriesId !== undefined ? `/content/${seriesId}` : undefined}
      >
        <Icon
          type={IconType.NavigationContentsHome}
          className="mr-16pxr h-24pxr w-24pxr shrink-0"
          onClick={onClickContentHome}
        />
      </UrlLink>
    </div>
  );
}
